import React from "react";
import loadable from "@loadable/component";
import { Navigate } from "react-router";
import { ReactComponent as UserIcon } from "../assets/icons/sidebar/user.svg";
import { ReactComponent as ContractIcon } from "../assets/icons/sidebar/contract.svg";
import { ReactComponent as TestIcon } from "../assets/icons/sidebar/test.svg";
import { ReactComponent as OrderIcon } from "../assets/icons/sidebar/order.svg";
import { ReactComponent as RecommendIcon } from "../assets/icons/sidebar/recommend.svg";
import { ReactComponent as ReportIcon } from "../assets/icons/sidebar/report.svg";
import { ReactComponent as CsIcon } from "../assets/icons/sidebar/cs.svg";
import { ReactComponent as EtcIcon } from "../assets/icons/sidebar/etc.svg";

//로그인 없이 이용가능 페이지
export const publicRoutes = [
  //첫시작 로그인으로 설정 => ('/' 해당 url 사용 안함)
  {
    exact: true,
    path: "/",
    component: () => {
      if (localStorage.getItem("token")) {
        return <Navigate to="/user/normal" />;
      } else {
        return <Navigate to="/login" />;
      }
    },
  },
  {
    exact: true,
    path: "/login",
    component: loadable(() => import("../pages/auth/Login")),
  },
];

//로그인 시에만 이용가능 페이지
export const privateRoutes = [
  {
    exact: true,
    path: "/user",
    redirect: "/user/normal",
    sidebar: {
      icon: <UserIcon />,
      label: "회원 관리",
    },
    isBranchVisible: true,
    children: [
      {
        exact: true,
        path: "/normal",
        sidebar: {
          label: "일반회원 리스트",
        },
        component: loadable(() => import("../pages/user/NormalList")),
        isBranchVisible: true,
      },
      {
        exact: true,
        visible: false,
        path: "/normal/detail/:id",
        component: loadable(() => import("../pages/user/NormalDetail")),
        isBranchVisible: true,
      },
      {
        exact: true,
        path: "/planner",
        sidebar: {
          label: "플래너회원 리스트",
        },
        component: loadable(() => import("../pages/user/PlannerList")),
        isBranchVisible: true,
      },
      {
        exact: true,
        visible: false,
        path: "/planner/detail/:id",
        component: loadable(() => import("../pages/user/PlannerDetail")),
        isBranchVisible: true,
      },
      {
        exact: true,
        path: "/consultant",
        sidebar: {
          label: "컨설턴트 리스트",
        },
        component: loadable(() => import("../pages/user/ConsultantList")),
      },
      {
        exact: true,
        visible: false,
        path: "/consultant/detail/:id",
        component: loadable(() => import("../pages/user/ConsultantDetail")),
      },
      {
        exact: true,
        visible: false,
        path: "/consultant/register",
        component: loadable(() => import("../pages/user/ConsultantRegister")),
      },
    ],
  },
  {
    exact: true,
    path: "/contract",
    sidebar: {
      icon: <ContractIcon />,
      label: "위촉계약 관리",
    },
    children: [
      {
        exact: true,
        path: "",
        sidebar: {
          label: "위촉계약 신청 리스트",
        },
        component: loadable(() => import("../pages/contract/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/detail/:id",
        component: loadable(() => import("../pages/contract/Detail")),
      },
    ],
  },
  {
    exact: true,
    path: "/test",
    sidebar: {
      icon: <TestIcon />,
      label: "시험 관리",
    },
    isBranchVisible: true,
    children: [
      {
        exact: true,
        path: "/region",
        sidebar: {
          label: "시험 응시지역 관리",
        },
        component: loadable(() => import("../pages/test/region/List")),
      },
      {
        exact: true,
        path: "/schedule",
        sidebar: {
          label: "시험 일정 관리",
        },
        component: loadable(() => import("../pages/test/schedule/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/schedule/detail/:id",
        component: loadable(() => import("../pages/test/schedule/Detail")),
      },
      {
        exact: true,
        visible: false,
        path: "/schedule/register",
        component: loadable(() => import("../pages/test/schedule/Register")),
      },
      {
        exact: true,
        path: "/request",
        sidebar: {
          label: "시험 접수 리스트",
        },
        component: loadable(() => import("../pages/test/request/List")),
        isBranchVisible: true,
      },
      {
        exact: true,
        visible: false,
        path: "/request/detail/:id",
        component: loadable(() => import("../pages/test/request/Detail")),
        isBranchVisible: true,
      },
    ],
  },
  {
    exact: true,
    path: "/order",
    sidebar: {
      icon: <OrderIcon />,
      label: "상품 주문 관리",
    },
    children: [
      {
        exact: true,
        path: "",
        sidebar: {
          label: "상품 주문 리스트",
        },
        component: loadable(() => import("../pages/order/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/detail/:id",
        component: loadable(() => import("../pages/order/Detail")),
      },
    ],
  },
  {
    exact: true,
    path: "/recommend",
    sidebar: {
      icon: <RecommendIcon />,
      label: "추천인 관리",
    },
    children: [
      {
        exact: true,
        path: "",
        sidebar: {
          label: "추천인 등록 내역",
        },
        component: loadable(() => import("../pages/recommend/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/detail/:id",
        component: loadable(() => import("../pages/recommend/Detail")),
      },
    ],
  },
  {
    exact: true,
    path: "/report",
    isBranchVisible: true,
    sidebar: {
      icon: <ReportIcon />,
      label: "보장분석 리포트 관리",
    },
    children: [
      {
        exact: true,
        path: "/list",
        sidebar: {
          label: "보장분석 신청 리스트",
        },
        component: loadable(() => import("../pages/report/ReportList")),
        isBranchVisible: true,
      },
      {
        exact: true,
        visible: false,
        path: "/detail",
        component: loadable(() => import("../pages/report/ReportDetail")),
        isBranchVisible: true,
      },
    ],
  },
  {
    exact: true,
    path: "/cs",
    sidebar: {
      icon: <CsIcon />,
      label: "고객센터 관리",
    },
    children: [
      {
        exact: true,
        path: "/faq",
        sidebar: {
          label: "자주 묻는 질문",
        },
        component: loadable(() => import("../pages/faq/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/faq/detail/:id",
        component: loadable(() => import("../pages/faq/Detail")),
      },
      {
        exact: true,
        visible: false,
        path: "/faq/register",
        component: loadable(() => import("../pages/faq/Register")),
      },
    ],
  },
  {
    exact: true,
    path: "/etc",
    sidebar: {
      icon: <EtcIcon />,
      label: "기타 관리",
    },
    children: [
      {
        exact: true,
        path: "/company",
        sidebar: {
          label: "보험사 관리",
        },
        component: loadable(() => import("../pages/etc/company/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/company/detail/:id",
        component: loadable(() => import("../pages/etc/company/Detail")),
      },
      {
        exact: true,
        visible: false,
        path: "/company/register",
        component: loadable(() => import("../pages/etc/company/Register")),
      },
      {
        exact: true,
        path: "/banner",
        sidebar: {
          label: "광고 배너 관리",
        },
        component: loadable(() => import("../pages/etc/banner/List")),
      },
      {
        exact: true,
        visible: false,
        path: "/banner/detail/:id",
        component: loadable(() => import("../pages/etc/banner/Detail")),
      },
      {
        exact: true,
        visible: false,
        path: "/banner/register",
        component: loadable(() => import("../pages/etc/banner/Register")),
      },
      {
        exact: true,
        path: "/notice",
        sidebar: {
          label: "공지 사항 관리",
        },
        component: loadable(() => import("../pages/notice/NoticeList")),
      },
      {
        exact: true,
        visible: false,
        path: "/notice/register",
        component: loadable(() => import("../pages/notice/NoticeRegister")),
      },
      {
        exact: true,
        visible: false,
        path: "/notice/detail",
        component: loadable(() => import("../pages/notice/NoticeDetail")),
      },
    ],
  },
];
